import { c as _c } from "react/compiler-runtime";
import { FilterChip } from "@components/common/faro-table/faro-table-filter/filter-chip";
import { FilterChipDropdownItem } from "@components/common/faro-table/faro-table-filter/filter-chip-dropdown-item";
import { LocationPartList } from "@components/projects/projects-filters/location-filter/location-part-list";
import { getProjectsLocationFilterPresets, getProjectsLocationNames, LOCATION_PART_LABELS, LOCATION_PARTS, NO_LOCATION_FILTER_ID, parseLocationNameFilterId } from "@components/projects/projects-filters/projects-location-filter-utils";
import { ChevronRightIcon, Menu, MenuItem, MenuSeparator } from "@flat-ui";
import { useStreamedProjects } from "@hooks/projects/use-streamed-projects";
import { useFilterQueryParams } from "@hooks/table-filters/use-filter-query-params";
import { Box, Stack } from "@mui-wrapper";
import { selectedSdbCompanyIdSelector } from "@store/sdb-company/sdb-company-selector";
import { useAppSelector } from "@store/store-helper";
import { PALETTE_VARS } from "@styles/palette-vars";
import { useState } from "react";

/** Width of the dropdown, which fits most names of cities and countries */
const DROPDOWN_WIDTH = "280px";
/**
 * A chip to filter the projects by location. It offers the projects without a location, and opens
 * the lists of the cities and countries of all the projects, which are loaded from the projects
 * stream when a list is first opened. The user can apply several of them at once.
 */
export function LocationFilterChip(t0) {
  const $ = _c(48);
  const {
    filteredColumn,
    label,
    projectArchivingState,
    tableType
  } = t0;
  const [anchorEl, setAnchorEl] = useState(null);
  const [shownPart, setShownPart] = useState();
  const companyId = useAppSelector(selectedSdbCompanyIdSelector);
  const t1 = shownPart !== undefined;
  let t2;
  if ($[0] !== companyId || $[1] !== projectArchivingState || $[2] !== t1) {
    t2 = {
      companyId,
      projectArchivingState,
      isEnabled: t1
    };
    $[0] = companyId;
    $[1] = projectArchivingState;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const {
    projects,
    fetchingStatus
  } = useStreamedProjects(t2);
  const {
    getFilterIdsForColumn,
    updateFilterItem
  } = useFilterQueryParams();
  let T0;
  let T1;
  let t10;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[4] !== anchorEl || $[5] !== fetchingStatus || $[6] !== filteredColumn || $[7] !== getFilterIdsForColumn || $[8] !== label || $[9] !== projects || $[10] !== shownPart || $[11] !== tableType || $[12] !== updateFilterItem) {
    const activeFilterIds = getFilterIdsForColumn(filteredColumn);
    let t11;
    if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
      t11 = getProjectsLocationFilterPresets();
      $[23] = t11;
    } else {
      t11 = $[23];
    }
    const noLocationFilter = t11[NO_LOCATION_FILTER_ID];
    let t12;
    if ($[24] !== filteredColumn || $[25] !== tableType || $[26] !== updateFilterItem) {
      t12 = function toggleFilter(filterId) {
        updateFilterItem({
          tableType,
          filteredColumn,
          filterId,
          shouldReplaceFilterInColumn: false
        });
      };
      $[24] = filteredColumn;
      $[25] = tableType;
      $[26] = updateFilterItem;
      $[27] = t12;
    } else {
      t12 = $[27];
    }
    const toggleFilter = t12;
    let t13;
    if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
      t13 = function closeDropdown() {
        setAnchorEl(null);
        setShownPart(undefined);
      };
      $[28] = t13;
    } else {
      t13 = $[28];
    }
    const closeDropdown = t13;
    T1 = Box;
    t9 = "div";
    const t14 = !!anchorEl;
    let t15;
    if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
      t15 = event => setAnchorEl(event.currentTarget);
      $[29] = t15;
    } else {
      t15 = $[29];
    }
    if ($[30] !== filteredColumn || $[31] !== label || $[32] !== t14) {
      t10 = <FilterChip filteredColumn={filteredColumn} label={label} shouldHaveDropdown={true} isDropdownOpen={t14} onClick={t15} />;
      $[30] = filteredColumn;
      $[31] = label;
      $[32] = t14;
      $[33] = t10;
    } else {
      t10 = $[33];
    }
    T0 = Menu;
    t3 = anchorEl;
    t4 = !!anchorEl;
    t5 = closeDropdown;
    t6 = DROPDOWN_WIDTH;
    if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
      t7 = {
        paper: {
          sx: {
            width: DROPDOWN_WIDTH,
            maxHeight: "400px",
            overflowY: "auto"
          }
        }
      };
      $[34] = t7;
    } else {
      t7 = $[34];
    }
    t8 = shownPart ? <LocationPartList part={shownPart} names={getListedNames(projects, shownPart, activeFilterIds)} isLoading={fetchingStatus === "uninitialized" || fetchingStatus === "pending"} activeFilterIds={activeFilterIds} onFilterClicked={toggleFilter} onBack={() => setShownPart(undefined)} onEscape={closeDropdown} /> : [<FilterChipDropdownItem key={NO_LOCATION_FILTER_ID} filterItem={noLocationFilter} isItemSelected={activeFilterIds.includes(NO_LOCATION_FILTER_ID)} onItemClicked={toggleFilter} shouldShowCheckbox={true} shouldShowCheckIconOnRight={false} shouldAllowLabelTranslation={true} />, <MenuSeparator key="separator" />, ...LOCATION_PARTS.map(part => <LocationPartItem key={part} part={part} isSelected={activeFilterIds.some(filterId_0 => isFilterOfPart(filterId_0, part))} onClick={() => setShownPart(part)} />)];
    $[4] = anchorEl;
    $[5] = fetchingStatus;
    $[6] = filteredColumn;
    $[7] = getFilterIdsForColumn;
    $[8] = label;
    $[9] = projects;
    $[10] = shownPart;
    $[11] = tableType;
    $[12] = updateFilterItem;
    $[13] = T0;
    $[14] = T1;
    $[15] = t10;
    $[16] = t3;
    $[17] = t4;
    $[18] = t5;
    $[19] = t6;
    $[20] = t7;
    $[21] = t8;
    $[22] = t9;
  } else {
    T0 = $[13];
    T1 = $[14];
    t10 = $[15];
    t3 = $[16];
    t4 = $[17];
    t5 = $[18];
    t6 = $[19];
    t7 = $[20];
    t8 = $[21];
    t9 = $[22];
  }
  let t11;
  if ($[35] !== T0 || $[36] !== t3 || $[37] !== t4 || $[38] !== t5 || $[39] !== t6 || $[40] !== t7 || $[41] !== t8) {
    t11 = <T0 anchorEl={t3} open={t4} onClose={t5} minWidth={t6} slotProps={t7}>{t8}</T0>;
    $[35] = T0;
    $[36] = t3;
    $[37] = t4;
    $[38] = t5;
    $[39] = t6;
    $[40] = t7;
    $[41] = t8;
    $[42] = t11;
  } else {
    t11 = $[42];
  }
  let t12;
  if ($[43] !== T1 || $[44] !== t10 || $[45] !== t11 || $[46] !== t9) {
    t12 = <T1 component={t9}>{t10}{t11}</T1>;
    $[43] = T1;
    $[44] = t10;
    $[45] = t11;
    $[46] = t9;
    $[47] = t12;
  } else {
    t12 = $[47];
  }
  return t12;
}

/** The item that opens the list of the cities or countries */
function LocationPartItem(t0) {
  const $ = _c(10);
  const {
    part,
    isSelected,
    onClick
  } = t0;
  const t1 = isSelected ? "primary.main" : "inherit";
  let t2;
  if ($[0] !== t1) {
    t2 = {
      flex: 1,
      alignItems: "center",
      justifyContent: "space-between",
      color: t1
    };
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = LOCATION_PART_LABELS[part];
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <ChevronRightIcon sx={{
      fontSize: "1rem",
      color: PALETTE_VARS.text.secondary
    }} />;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== t2 || $[4] !== t3.name) {
    t5 = <Stack direction="row" sx={t2}>{t3.name}{t4}</Stack>;
    $[3] = t2;
    $[4] = t3.name;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== isSelected || $[7] !== onClick || $[8] !== t5) {
    t6 = <MenuItem disableRipple={true} selected={isSelected} onClick={onClick}>{t5}</MenuItem>;
    $[6] = isSelected;
    $[7] = onClick;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  return t6;
}

/**
 * Returns the cities or countries of the projects. The applied ones are listed too, even if no
 * project has them, e.g. from an old link, so the user can remove them.
 */
function getListedNames(projects, part, activeFilterIds) {
  const appliedNames = activeFilterIds.flatMap(filterId => {
    const locationName = parseLocationNameFilterId(filterId);
    return locationName?.part === part ? [locationName.name] : [];
  });
  const names = new Set([...getProjectsLocationNames(projects, part), ...appliedNames]);
  return [...names].sort((a, b) => a.localeCompare(b));
}

/** Whether the filter is for the projects without the part, or in one of its cities or countries */
function isFilterOfPart(filterId, part) {
  return filterId === LOCATION_PART_LABELS[part].noneFilterId || parseLocationNameFilterId(filterId)?.part === part;
}